import http from 'services/http'
import { buildUrl } from 'app/utils'

const contratoInstituicaoUrl = buildUrl('/contrato/instituicao')
const instituicaoRhUrl = buildUrl('/rh/instituicoes')
const adminInstituicaoUrl = buildUrl('admin/instituicoes')

export const findAll = (params = {}) => http.get(contratoInstituicaoUrl(), params)

export const findAllEstabelecimentosByInstituicao = idInstituicao =>
  http.get(instituicaoRhUrl(`${idInstituicao}/estabelecimentos`))

export const getInstituicoesVinculadasEmpresa = params => http.get(adminInstituicaoUrl(), params)

export const getIsLicitacao = () => http.get(contratoInstituicaoUrl('licitacao'))

export default {
  findAll,
  findAllEstabelecimentosByInstituicao,
  getInstituicoesVinculadasEmpresa,
  getIsLicitacao
}
